/**
 * @description Returns the base name of a file
 */
const getFileBaseName = (filePath: string): string => {
  return filePath.split('/').pop() || filePath;
};

/**
 * @description Logs an error to the console
 */
export const logErrorMessage = (error: unknown, errorSource?: string): void => {
  const rootMessage = `Error${errorSource ? ` in ${getFileBaseName(errorSource)}` : ''}:`;
  if (error instanceof Error) {
    console.error(rootMessage, error.message);
    return;
  }
  console.error(rootMessage, String(error));
};

/**
 * @description Returns the error message from an error object or string
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getErrorMessage = (error: any, errorSource?: string): string => {
  if (error instanceof Error) {
    logErrorMessage(error, errorSource);
    return error.message;
  }
  logErrorMessage(String(error.message ?? error), errorSource);
  return String(error);
};
